export type SberQrSaveSource = {
  transferUrl?: string;
  qrDataUrl?: string;
  qrCodeUrl?: string;
};

export const getSberQrSaveUrl = ({
  transferUrl,
  qrDataUrl,
  qrCodeUrl,
}: SberQrSaveSource): string | undefined =>
  transferUrl ? qrDataUrl : qrCodeUrl;
